import { useTranslation } from 'react-i18next';

import WarningIcon from '@mui/icons-material/Warning';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { useHostingAccount } from '@newfold/huapi-js';

import Tooltip from '~/components/CommonTooltip';
import useAccount from '~/hooks/useAccount';
import ServerSetupTooltipContent from '~/Nova/scenes/HostingList/components/ServerSetupTooltipContent';

type AdvancedHostingServerSetupProps = {
  hostname?: string;
  isDomainServiceConfigured: boolean;
};

const AdvancedHostingServerSetup = ({
  hostname = '',
  isDomainServiceConfigured,
}: AdvancedHostingServerSetupProps) => {
  const { t } = useTranslation('settings', {
    keyPrefix: 'nameServerAndIPCard.advHostingServerInfo',
  });
  const { id: hostingId } = useAccount();
  const { data: hostingAccount } = useHostingAccount(hostingId, {
    query: { enabled: Boolean(hostingId) },
  });

  const tooltipContent = (
    <ServerSetupTooltipContent
      accountType={hostingAccount?.data?.type}
      hasHostname={Boolean(hostname?.trim())}
    />
  );

  return (
    <>
      {hostname && (
        <Typography
          variant="body2"
          textAlign={'left'}
          sx={{ wordWrap: 'break-word' }}
        >
          {hostname}
        </Typography>
      )}
      {!isDomainServiceConfigured && (
        <Stack direction="row" spacing={1} alignItems="center">
          <WarningIcon color="warning" />
          <Link href="/setup-server">
            <Typography variant="body2">{t('runServerSetup')}</Typography>
          </Link>
          <Tooltip title={tooltipContent} />
        </Stack>
      )}
    </>
  );
};

export default AdvancedHostingServerSetup;
